<template>
    <section class="m-author-info">
        <div class="m-author-info__content">
            <div class="info-content">
                <div class="info-content__author-more">
                    <div class="author-more">
                        <div class="author-more__author">
                            <div class="author-info">
                                <div
                                    v-if="publisher.avatar && publisher.avatar.length"
                                    class="author-info__avatar"
                                >
                                    <img

                                        :src="imgSrc(publisher.avatar[0])"
                                        :alt="$t('blog.alt.avatar')"
                                        class="author-avatar-img"
                                    >
                                </div>
                                <div class="author-info__details">
                                    <span class="author-career">{{ $t('blog.author') }}</span>
                                    <span class="author-name">{{ publisher.name_full }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="author-more__link-lg">
                            <router-link :to="{name:'blog-author', params: {id: publisher.id}}">
                                <span class="more-articles-from">{{ $t('blog.more_articles', [publisher.name_full.split(' ')[0]]) }}</span>
                                <img
                                    src="@/modules/blog/assets/arrow-forward.png"
                                    :alt="$t('blog.alt.arrow')"
                                    class="blog-link-arrow"
                                >
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="info-content__description">
                    {{ publisher.biography }}
                </div>
                <div class="info-content__link-md">
                    <router-link
                        :to="{name:'blog-author', params: {id: publisher.id}}"
                    >
                        <span class="more-articles-from">
                            {{ $t('blog.more_articles', [publisher.name_full.split(' ')[0]]) }}</span>
                        <img
                            src="@/modules/blog/assets/arrow-forward.png"
                            :alt="$t('blog.alt.arrow')"
                            class="author-avatar-img"
                        >
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script >

    export default {
        name: 'BlogAuthorInfo',

        /**
         *
         * @inheritDoc
         */
        props: {
            publisher: {
                type: Object,
            },

        },

    };

</script>

<style lang="scss" src="./author-info.scss"/>
